var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"role"},[_c('div',{staticClass:"open-wrap"},[_c('new-Insert',{attrs:{"type":"update","clearData":_vm.clearData,"formData":_vm.formData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }